import type { FunctionComponent } from 'react'
import type { NutritionalValueOfProductResult } from '../../data/NutritionalValueOfProductFragment'
import { IconItem } from './IconItem'
import style from './IconItem.module.sass'

type IconItemGroupProps = {
	title: string
	items: NutritionalValueOfProductResult[]
}

export const IconItemGroup: FunctionComponent<IconItemGroupProps> = ({ items, title }) => {
	return (
		<>
			<h2 className={style.groupTitle}>{title}</h2>
			<div className={style.group}>
				{items.map((item) => (
					<IconItem
						key={item.id}
						title={item.nutritionalValue?.name}
						iconUrl={item.nutritionalValue?.icon?.url}
						value={item.amount}
					/>
				))}
			</div>
		</>
	)
}
